<div class="big-card-page" data-test="forgotten-password-wrapper">
  <div class="big-card-page__card">
    <div class="big-card-page__icon">
      <img [src]="'/assets/images/icons/' + iconFileName + '.svg'" alt="" />
    </div>
    <div
      class="big-card-page__title"
      [innerHTML]="'FORGOTTEN_PASSWORD.' + contentTranslateKey + '.TITLE' | translate"
      data-test="forgotten-password-title"
    ></div>
    <div
      class="big-card-page__desc"
      [innerHTML]="'FORGOTTEN_PASSWORD.' + contentTranslateKey + '.DESCRIPTION' | translate"
      data-test="forgotten-password-description"
    ></div>
    <div class="big-card-page__form">
      <form [formGroup]="emailControl" *ngIf="!formSent" (submit)="submit()">
        <div class="rm-field">
          <input
            [formControl]="emailControl"
            [placeholder]="'FORGOTTEN_PASSWORD.FORM.EMAIL_INPUT.LABEL' | translate"
            type="email"
            name="email"
            class="rm-input rm-input--with-errors rm-input--center"
            data-test="forgotten-password-email-input"
          />
        </div>
        <button
          [disabled]="(submitted && !emailControl.valid) || submitting"
          class="rm-button rm-button--full-width rm-button--primary"
          data-test="forgotten-password-submit"
        >
          {{ 'FORGOTTEN_PASSWORD.FORM.SUBMIT' | translate }}
        </button>
      </form>
      <div *ngIf="formSent">
        <b>{{ 'FORGOTTEN_PASSWORD.YOU_CAN_CLOSE_WINDOW' | translate }}</b>
      </div>
    </div>
    <div
      *ngIf="!formSent"
      class="big-card-page__extra-action"
      data-test="forgotten-password-back-to-connection"
    >
      <a [routerLink]="['/login']" queryParamsHandling="merge"
        >{{ 'FORGOTTEN_PASSWORD.BACK_TO_CONNECTION' | translate }}</a
      >
    </div>
  </div>
</div>
